var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("미디어 등록")])]), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-5"
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "우선 순위",
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.form.rank,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rank", $$v);
      },
      expression: "form.rank"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2"
  }, [_c('v-select', {
    attrs: {
      "label": "라벨",
      "items": ['미디어', '유튜브'],
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.form.label,
      callback: function ($$v) {
        _vm.$set(_vm.form, "label", $$v);
      },
      expression: "form.label"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "공지여부",
      "dense": "",
      "inset": "",
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.form.isNotice,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isNotice", $$v);
      },
      expression: "form.isNotice"
    }
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.form.title,
      callback: function ($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "비디오 아이디",
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.form.videoId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "videoId", $$v);
      },
      expression: "form.videoId"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.form.thumbnail ? _c('v-img', {
    attrs: {
      "width": "48",
      "height": "48",
      "src": _vm.createObjectURL(_vm.form.thumbnail)
    }
  }) : _c('v-responsive', {
    staticClass: "grey lighten-2",
    attrs: {
      "width": "48",
      "height": "48"
    }
  }, [_c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2"
  }, [_c('v-file-input', {
    attrs: {
      "label": "비디오 썸네일",
      "hide-details": "",
      "persistent-placeholder": "",
      "show-size": "",
      "accept": "image/*"
    },
    model: {
      value: _vm.form.thumbnail,
      callback: function ($$v) {
        _vm.$set(_vm.form, "thumbnail", $$v);
      },
      expression: "form.thumbnail"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }